import { DEFAULTS } from '../defaults.js';
import { getModalStyles, TOOLBARS, BUTTON_TYPES, decorateComponentWithProps, getBottomToolbarModalStyles } from 'wix-rich-content-editor-common';
import EmbedURLInputModal from './embedURLInputModal.js';
import { MOBILE_FULL_SCREEN_CUSTOM_STYLE, DesktopFlyOutModalStyles, DesktopOverlayModalStyles } from 'wix-rich-content-ui-components';
import { modalContentStyles } from '../consts.js';
import InstagramIcon from '../icons/InstagramIcon.js';
import TwitterIcon from '../icons/TwitterIcon.js';
import FacebookIcon from '../icons/FacebookIcon.js';
import TikTokIcon from '../icons/TikTokIcon.js';
import PinterestIcon from '../icons/PinterestIcon.js';
import YoutubeIcon from '../icons/YoutubeIcon.js';
import 'prop-types';
import 'react';
import './SocialEmbedInsertModal.js';
import '../types.js';
import 'wix-rich-content-common';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createInsertButtons = ({
  t,
  settings,
  isMobile,
  experiments = {}
}) => {
  const { newVideoVerticalAndSocialModals } = experiments;
  const useNewModal = newVideoVerticalAndSocialModals == null ? void 0 : newVideoVerticalAndSocialModals.enabled;
  const content = isMobile ? {
    maxWidth: 580,
    minHeight: "100%",
    minWidth: "100%",
    margin: 0,
    alignContent: "center",
    top: 0,
    transform: "none"
  } : { maxWidth: 580, minHeight: 348 };
  const newModalCustomStyles = isMobile ? MOBILE_FULL_SCREEN_CUSTOM_STYLE : __spreadProps(__spreadValues({}, DesktopFlyOutModalStyles), { content: modalContentStyles });
  const customStyles = useNewModal ? newModalCustomStyles : { content };
  const defaultModalStyles = getModalStyles({
    customStyles,
    fullScreen: !!useNewModal,
    isMobile
  });
  const newModalStyles = isMobile ? defaultModalStyles : void 0;
  const modalStyles = useNewModal ? newModalStyles : defaultModalStyles;
  const modalStylesFn = useNewModal ? ({ buttonRef, toolbarName }) => {
    return getBottomToolbarModalStyles(
      buttonRef,
      {
        customStyles
      },
      toolbarName
    );
  } : void 0;
  const { exposeEmbedButtons = [] } = settings;
  const socialIconsMap = {
    Instagram: InstagramIcon,
    Twitter: TwitterIcon,
    Facebook: FacebookIcon,
    TikTok: TikTokIcon,
    Pinterest: PinterestIcon,
    YouTube: YoutubeIcon
  };
  const baseButtonsProps = (socialType) => ({
    type: BUTTON_TYPES.MODAL,
    modalStylesFn,
    section: "BlockToolbar_Section_Embed_Anywhere",
    componentData: DEFAULTS,
    name: `${socialType}_InsertButton`,
    tooltip: t(`${socialType}Plugin_InsertButton_Tooltip`),
    getIcon: () => socialIconsMap[socialType],
    modalElement: decorateComponentWithProps(EmbedURLInputModal, {
      fetchData: settings.fetchData,
      socialType
    })
  });
  const toolbars = useNewModal ? [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE] : [TOOLBARS.INSERT_PLUGIN, TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE];
  let socialButtons = exposeEmbedButtons.map((socialType) => __spreadProps(__spreadValues({}, baseButtonsProps(socialType)), {
    toolbars,
    modalStyles
  }));
  if (useNewModal) {
    const externalToolbarButtons = exposeEmbedButtons.map((socialType) => __spreadProps(__spreadValues({}, baseButtonsProps(socialType)), {
      toolbars: [TOOLBARS.INSERT_PLUGIN],
      modalStyles: getModalStyles({
        customStyles: __spreadValues(__spreadValues({}, customStyles), DesktopOverlayModalStyles),
        fullScreen: isMobile,
        isMobile
      })
    }));
    socialButtons = [...socialButtons, ...externalToolbarButtons];
  }
  return socialButtons;
};

export { createInsertButtons as default };
//# sourceMappingURL=insert-buttons.js.map
